/**
 * Map: one floating tooltip for .map markers (data-map-tooltip + template id map-tooltip-*).
 * Desktop / hover; extend later for focus, clamping, keyboard.
 */
import { initAnchorTooltips } from "./anchor-tooltips.js";

function boot() {
  initAnchorTooltips(".map", {
    tooltipId: "map-tooltip",
    templatePrefix: "map-tooltip-",
    markerSelector: ".map__stack--desktop [data-map-tooltip]",
    markerDataAttr: "data-map-tooltip",
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
